import React from "react";


const NextarrowIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7.414" height="12.828" viewBox="0 0 7.414 12.828">
            <path id="chevron-right" d="M9,16l5-5L9,6" transform="translate(-7.586 -4.586)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>

    );

}

export default NextarrowIcon;